/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.29",
    versionName: "0.2.0-nightly.2025.10.29",
    versionChannel: "nightly",
    buildDate: "2025-10-29T00:09:19.450Z",
    commitHash: "a0916bff7affc9ba571605fbebb6380984fd3476",
};
